import _extends from '@babel/runtime/helpers/extends';
import * as React from 'react';
import { ClickAwayListener, Popper as Popper$1, Fade } from '@mui/material';
import { Paper } from '../Paper/Paper.js';

var Popper = function Popper(_ref) {
  var containerRef = _ref.containerRef,
      disablePortal = _ref.disablePortal,
      handleClickAway = _ref.handleClickAway,
      _ref$hasTransition = _ref.hasTransition,
      hasTransition = _ref$hasTransition === void 0 ? true : _ref$hasTransition,
      menu = _ref.menu,
      menuPaperClassName = _ref.menuPaperClassName,
      open = _ref.open,
      popperAnchorRef = _ref.popperAnchorRef,
      popperClassName = _ref.popperClassName,
      popperPosition = _ref.popperPosition,
      popperRef = _ref.popperRef,
      trigger = _ref.trigger,
      sx = _ref.sx,
      sxPaper = _ref.sxPaper;
  return /*#__PURE__*/React.createElement(ClickAwayListener, {
    onClickAway: function onClickAway(event) {
      return open && handleClickAway(event);
    }
  }, /*#__PURE__*/React.createElement("div", {
    ref: containerRef
  }, trigger, /*#__PURE__*/React.createElement(Popper$1, {
    ref: popperRef,
    disablePortal: disablePortal,
    open: open,
    anchorEl: popperAnchorRef.current,
    className: popperClassName,
    sx: sx,
    placement: popperPosition,
    transition: hasTransition
  }, hasTransition ? function (_ref2) {
    var TransitionProps = _ref2.TransitionProps;
    return /*#__PURE__*/React.createElement(Fade, _extends({}, TransitionProps, {
      timeout: 350
    }), /*#__PURE__*/React.createElement(Paper, {
      elevation: 2,
      className: menuPaperClassName,
      sx: sx
    }, menu));
  } : /*#__PURE__*/React.createElement(Paper, {
    elevation: 2,
    className: menuPaperClassName,
    sx: sxPaper
  }, menu))));
};

Popper.defaultProps = {
  popperPosition: 'bottom-end'
};
Popper.displayName = 'Popper';
export { Popper };